<script setup lang="ts">
import { computed } from "vue";
import { useDeviceState } from "@/stores/DeviceState";

/**
 * Pastille d'information posée sur un item de liste (nb de rapports, plan
 * rattaché à un ouvrage…). L'icône est fournie via le slot `icon` : on réutilise
 * celle de l'item correspondant (MapIcon, DwgIcon, TemplateIcon) pour que le
 * rappel soit lu instantanément. Au doigt, le tooltip s'ouvre au clic et le clic
 * ne remonte pas à l'item — sinon on ouvrirait le plan en voulant lire l'info.
 */

defineProps<{
  tooltip: string;
  /** Affiché à côté de l'icône ; masqué si absent */
  count?: number;
}>();

const device = useDeviceState();

const isTouch = computed(() => device.isTouchDevice());

const trigger = computed(() => (isTouch.value ? "click" : "hover"));
</script>

<template>
  <el-tooltip
    :content="tooltip"
    :trigger="trigger"
    effect="dark"
    placement="top"
  >
    <span class="item-indicator" @click.stop.prevent>
      <slot name="icon" :size="16" />
      <span v-if="count !== undefined" class="indicator-count">{{ count }}</span>
    </span>
  </el-tooltip>
</template>

<style lang="scss" scoped>
.item-indicator {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-secondary-color);
  font-size: 11px;
  line-height: 1.4;
  cursor: default;
}

.indicator-count {
  font-weight: 600;
}
</style>
